import React from 'react';
import './DeliveryProgress.css';
import { FaClock, FaTruck } from 'react-icons/fa';

const STATUS_LIST = [
  { key: 'Open', label: 'Open', color: '#2196f3' },
  { key: 'Verification', label: 'Verification', color: '#ffb300' },
  { key: 'Prepare', label: 'Prepare', color: '#26c6da' },
  { key: 'Ready', label: 'Ready', color: '#2196f3', highlight: true },
  { key: 'Assigned', label: 'Assigned', color: '#757575' },
  { key: 'Processing', label: 'Processing', color: '#43a047' },
];

const DeliveryProgress = ({ deliveries = [],title }) => {
  return (
    <div className="delivery-progress-container">
      <h2 className="delivery-progress-heading">
        {title}
      </h2>
      {/* Legend */}
      <div className="delivery-legend">
        {STATUS_LIST.map(status => (
          <span className="legend-item" key={status.key}>
            <span className="legend-dot" style={{ background: status.color, border: status.highlight ? '2px solid #fff' : 'none' }}></span>
            <span className="legend-label">{status.label}</span>
          </span>
        ))}
      </div>
      {/* Delivery Rows */}
      <div className="delivery-list">
        {deliveries.map((delivery, idx) => (
          <div className="delivery-row" key={delivery.mrn + idx}>
            <div className="delivery-time-status">
              <FaClock className="clock-icon" />
              <span>{delivery.timeStatus}</span>
            </div>
            <div className="delivery-mrn">{delivery.mrn}</div>
            <div className="delivery-progress-bar">
              {STATUS_LIST.map((status, sIdx) => {
                const isCurrent = status.key === delivery.currentStatus;
                return (
                  <div
                    className={`progress-segment${isCurrent ? ' current' : ''}`}
                    key={status.key}
                    style={{ background: status.color }}
                  >
                    {isCurrent && <span className="blinker" />}
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DeliveryProgress; 